<header class="dialog-title">{{ 'driver.' + (isPreviousStateEdit ? 'edit' : 'new') | translate }}</header>

<div class="dialog-subheader">{{ 'driver.select-image' | translate }}</div>

<div class="content">
  @for (avatar of (avatarList$ | async); track avatar) {
    <div
      class="box-image"
      [ngClass]="{selected: selectedAvatar === avatar}"
      (click)="onSelect(avatar)"
      >
      <img [src]="avatar" alt="avatar">
    </div>
  }
</div>

<div class="dialog-box-buttons">
  <button mat-button class="button major" (click)="onCancel()">{{ 'action.back' | translate }}</button>
</div>
